import { InitVerificationRequest, InitVerificationEvent, BusinessData, KeycloakProfile } from './../../api/models/api-models';
import { ClaimingStage, VerificationScreens, OptionsVerificationType, OptionsOrder } from '../../api/models/claiming.models';
import { CLAIMING_LOCAL_STORAGE_KEY } from './../../api/models/claiming.models';

export function getClaimingStageUtil(
  awaitingOwnership: boolean,
  needsVerification: boolean,
  oAuthStatus: boolean,
  claimingCompletedStatus: boolean,
  wrongOwnershipType?: boolean
): ClaimingStage {
  let claimingStage: ClaimingStage;

  const isFirstStage = !claimingCompletedStatus && awaitingOwnership && !oAuthStatus;
  const isSecondStage = (!claimingCompletedStatus && awaitingOwnership && oAuthStatus) || !!wrongOwnershipType;
  const isFourthStage = (claimingCompletedStatus || !awaitingOwnership) && needsVerification;
  const isFifthStage = (claimingCompletedStatus || !awaitingOwnership) && !needsVerification;

  if (isFirstStage) {
    claimingStage = ClaimingStage.STAGE1;
  } else if (isSecondStage) {
    claimingStage = ClaimingStage.STAGE2;
  } else if (isFourthStage) {
    claimingStage = ClaimingStage.STAGE4;
  } else if (isFifthStage) {
    claimingStage = ClaimingStage.STAGE5;
  }
  return claimingStage;
}

export function reOrderVerificationOptions(currentOptions: OptionsVerificationType[]): OptionsVerificationType[] {
  const orderedOptions = [];
  OptionsOrder.forEach(option => {
    let match = false;
    currentOptions.filter(currentOption => {
      if (!match && currentOption === option) {
        orderedOptions.push(currentOption);
        match = true;
        return false;
      } else {
        return true;
      }
    });
  });
  return orderedOptions;
}

export function setLocalStorageClaimingFlag(): void {
  const startedClaiming = localStorage.getItem(CLAIMING_LOCAL_STORAGE_KEY);
  if (!startedClaiming) {
    localStorage.setItem(CLAIMING_LOCAL_STORAGE_KEY, 'true');
  }
}

/**
 * In case the selected verification option is ADDRESS, the screen that shall be displayed after the user clicks in "Receive code" is ON_ITS_WAY
 */
export function getVerifyScreenToDisplay(currentOption: OptionsVerificationType): VerificationScreens {
  return currentOption === OptionsVerificationType.ADDRESS ? VerificationScreens.ON_ITS_WAY : VerificationScreens.PERFORM_VERIFY;
}

/**
 * In case the current selected verification option is SMS or PHONE_CALL, the currentOption shall be set to PHONE (generic)
 */
export function getCodeNotReceivedSelectedOption(currentOption: OptionsVerificationType): OptionsVerificationType {
  return currentOption;
}

/**
 * Builds the verification init request
 */
export function buildInitRequest(payload: InitVerificationEvent, languageCode: string): InitVerificationRequest {
  const getInput = () => {
    switch (payload.selectedOption) {
      case OptionsVerificationType.ADDRESS:
        return { mailerContactName: payload.verificationBusinessData.mailerContactName };
      case OptionsVerificationType.EMAIL:
        return { emailAddress: payload.verificationBusinessData.EMAIL };
      case OptionsVerificationType.PHONE_CALL:
        return { phoneNumber: payload.verificationBusinessData.PHONE };
      case OptionsVerificationType.SMS:
        return { phoneNumber: payload.verificationBusinessData.PHONE };
      default:
        return { phoneNumber: payload.verificationBusinessData.PHONE };
    }
  };

  return {
    input: getInput(),
    method: payload.selectedOption,
    languageCode,
  };
}

/**
 * Util method to build the user Contact name
 * If the business data has no user name, then the information from the keycloak profile is used instead
 */
export function buildUserContactname(business: BusinessData, userProfile: KeycloakProfile): string {
  const keycloakUsername = userProfile ? `${userProfile.firstName} ${userProfile.lastName}` : '';
  return business && business.userFirstName && business.userLastName ? `${business.userFirstName} ${business.userLastName}` : keycloakUsername;
}

export function clearLocalStorageClaimingKey(): void {
  localStorage.removeItem(CLAIMING_LOCAL_STORAGE_KEY);
}

export function getClaimBusinessData(businessData: BusinessData): BusinessData {
  return {
    userFirstName: businessData.userFirstName,
    userLastName: businessData.userLastName,
    name: businessData.name,
    additional: '',
    zipCode: businessData.zipCode,
    city: businessData.city,
    street: businessData.street,
    establishmentId: businessData.establishmentId,
    countryCode: businessData.countryCode,
    languageCode: businessData.languageCode,
    url: businessData.url,
    contactEmail: businessData.contactEmail,
    contactPhoneNumber: businessData.contactPhoneNumber,
    openingTimes: businessData.openingTimes,
    specialOpeningTimes: businessData.specialOpeningTimes,
    offers: businessData.offers,
    category: businessData.category,
    services: businessData.services,
    paymentMethods: businessData.paymentMethods,
  };
}
